<div class="single-header">
    <a [routerLink]="['/' + routesConstants.HOME_NAVIGATION]"><img [src]="imagePathConstants.GENERAL+'/wedshed-logo.svg'" width="124"
                                                                   height="52" alt="Logo" loading="lazy"></a>
</div>

<div class="single-wrap">
    <div class="single-wrap-inner">
        <div class="single-title" data-content="302">
            302
        </div>
        <div class="single-subtitle">
            {{ redirectMessage }}
        </div>
        <div class="single-wrap-action">
            <a [routerLink]="['/' + redirectUrl]" class="primary-btn">Explore More</a>
        </div>
    </div>
</div>
